// extracted by mini-css-extract-plugin
export var button = "VideoTestimonialsModule-module--button--bdf3a";
export var buttonGroup = "VideoTestimonialsModule-module--buttonGroup--d6189";
export var carousel = "VideoTestimonialsModule-module--carousel--c897b";
export var carouselContainer = "VideoTestimonialsModule-module--carouselContainer--96026";
export var noArrows = "VideoTestimonialsModule-module--noArrows--d12a8";
export var visuallyHidden = "VideoTestimonialsModule-module--visuallyHidden--3354a";